

/* 
    section-banners
*/

import '../sections/section-banner';

import '../../sass/layout/sections/section-stats.scss';

import '../sections/section-categories';

import '../sections/section-maps';

import '../sections/section-realizations';

import '../sections/section-news';

// import '../sections/section-carousel-switch';

// import '../sections/section-bestseller';

// import '../sections/section-heroes';

// import '../sections/section-opinions';

// import '../sections/section-newsletter';




